import { Flex, IconButton, Tooltip, useColorModeValue } from "@chakra-ui/react";

import {
  IcoColorModeDark,
  IcoColorModeLight,
  IcoColorModeSystem,
} from "@/common/components/Icons";
import useColorModeStorage, {
  StoredColorMode,
} from "@/common/hooks/useColorModeStorage";

import { AppProfileMenu } from "./AppProfileMenu";

const colorModeLabels = {
  dark: {
    label: "Dark mode",
    icon: <IcoColorModeDark size="sm" />,
  },
  light: {
    label: "Light mode",
    icon: <IcoColorModeLight size="sm" />,
  },
  system: {
    label: "System color mode",
    icon: <IcoColorModeSystem size="sm" />,
  },
} as const satisfies Record<
  StoredColorMode,
  { label: string; icon: React.ReactNode }
>;

export function AppFooter() {
  const [colorMode, toggleColorMode] = useColorModeStorage();

  return (
    <Flex align="center" gap={1} justify="space-between" px={2}>
      <AppProfileMenu />

      <Tooltip label={colorModeLabels[colorMode].label} hasArrow>
        <IconButton
          _hover={{ color: useColorModeValue("gray.800", "gray.200") }}
          aria-label="Toggle color mode"
          color="dimmed"
          icon={colorModeLabels[colorMode].icon}
          mr={-3}
          size="xs"
          variant="ghost"
          onClick={toggleColorMode}
        />
      </Tooltip>
    </Flex>
  );
}
